"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toCSSValue = exports.parse = void 0;
const backdrop_filter_1 = require('./backdrop-filter.cjs');
const backdrop_filter_2 = require('./backdrop-filter.cjs');
const parse = (value) => (0, backdrop_filter_1.parse)(value);
exports.parse = parse;
const toCSSValue = (value) => (0, backdrop_filter_2.toCSSValue)(value);
exports.toCSSValue = toCSSValue;
